import React from 'react';
import '../Demo.scss';
import {Box, Typography} from '@mui/material';
import {Link} from 'react-router-dom';
import ArrPieChart from '../../../components/common/arr-piechart/ArrPieChart';

const COLORS = ['#7DDFBB', '#FFC37D'];

const PieChart: React.FC = () => {
  return (
    <Box className="pie-chart-demo">
      <h1>Pie Chart</h1>
      <Typography></Typography>
      <hr />
      <Link to="/demo" className="link">
        Return
      </Link>
      <hr />
      <Box className="pie-chart-contr">
        <div className="pie-chart-demo">
          <ArrPieChart
            title="Total distributed: "
            data={[
              {
                id: '1',
                value: 85,
                label: 'Completed',
                color: COLORS[0],
              },
              {
                id: '2',
                value: 25,
                label: 'To Do',
                color: COLORS[1],
              },
            ]}
            total={110}
          />
        </div>
        <div className="pie-chart-demo">
          <ArrPieChart
            title="Empty Example "
            data={[
              {id: 'completed', value: 0, label: 'Completed', color: COLORS[0]},
              {id: 'todo', value: 0, label: 'To Do', color: COLORS[1]},
            ]}
            total={0}
          />
        </div>
      </Box>
    </Box>
  );
};

export default PieChart;
